import React from "react";
import { connect } from "react-redux";
import { Button, Row, Col } from "reactstrap";
import {
  Label,
  Input,
  FormText,
  FormGroup,
} from "reactstrap";

import { Field, reduxForm, FieldArray,formValueSelector } from "redux-form";
import "react-dropdown/style.css";
import { CardHeader, CardBody } from 'reactstrap';
import renderSelectField from '../../../../shared/components/form/Select';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import renderDatePickerField from "../../../../shared/components/form/DatePicker";
import {createNewLabelToggle, createLabel} from "../../../../redux/actions/feedbackActions";
import CreateNewFaultForm from "./CreateNewFaultForm";

const validate = values => {
    const errors = {};
    if (!values.ai_decision_quality) {
        errors.name = "Please select AI decision quality";
    }
    return errors;
};


const renderField =
    ({
         input, placeholder, type, meta: { touched, error },
     }) => (
        <div className="form__form-group-input-wrap form__form-group-input-wrap--error-above">
            <input {...input} placeholder={placeholder} type={type} />
            {touched && error && <span className="form__form-group-error">{error}</span>}
        </div>
    );

renderField.propTypes = {
    input: PropTypes.shape().isRequired,
    placeholder: PropTypes.string,
    type: PropTypes.string,
    meta: PropTypes.shape({
        touched: PropTypes.bool,
        error: PropTypes.string,
    }),
};

renderField.defaultProps = {
    placeholder: '',
    meta: null,
    type: 'text',
};


let FeedbackReportForm = props => {

    const {
        t,
        handleSubmit,
        submitting,
        initialValues,
        corrected_event_type,
        labelManager
    } = props;

    const AI_DECISION_OPTIONS = [{ value: 'ACCURATE', label: 'Accurate' },
                            { value: 'SOMEWHAT_ACCURATE', label: 'Somewhat Accurate' },
                            { value: 'SOMEWHAT_INCORRECT', label: 'Somewhat Incorrect' },
                            { value: 'INCORRECT', label: 'Incorrect' }];


    const EVENT_TYPE_OPTIONS = [{ value: 'ANOMALY', label: 'ANOMALY' },
                            { value: 'FAULT', label: 'FAULT' },
                            { value: 'FAILURE_PREDICTION', label: 'FAILURE PREDICTION' },
                            { value: 'HEALTH_PREDICTION', label: 'HEALTH PREDICTION' }];

    const SEVERITY_OPTIONS = [{ value: 'CRITICAL', label: 'CRITICAL' },
                            { value: 'MAJOR', label: 'MAJOR' },
                            { value: 'MINOR', label: 'MINOR' },
                            { value: 'NORMAL', label: 'NORMAL' }];

   function handleCreateNewLabel(labelData, isCreateNewLabel) {
       if(labelData) {
            let data ={}
            data["label_list"]=[labelData];
            data["ai_type"] = corrected_event_type.value;
            data["label_manager_id"] =labelManager._id;
            console.log("New Label Data:");
            console.log(data);
            props.createLabel(data);
       }
       props.createNewLabelToggle(isCreateNewLabel);
   };

   function onLabelItemSelect(res)  {
        if(res.value === "CREATE_NEW"){
            props.createNewLabelToggle(!props.isCreateNewLabel);
        }
   };



   function buildCorrectEventLabels(cevent_type, labelManager)  {
        let labels = [];
        if (labelManager) {
            if(cevent_type.value === "ANOMALY"){
                    labels = labelManager.anomaly_labels.label_list;
            } else if(cevent_type.value === "FAULT"){
                    labels = labelManager.fault_labels.label_list;
            } else if(cevent_type.value === "FAILURE_PREDICTION"){
                    labels = labelManager.failure_prediction_labels.label_list;
            } else if(cevent_type.value === "HEALTH_PREDICTION"){
                    labels = labelManager.health_prediction_labels.label_list;
            }
        }
        console.log(labels);
        let label_options =[];
        label_options.push({ value: 'CREATE_NEW', label: 'Create New' });
        let i =0;
        let new_option = null;
        for (i = 0; i < labels.length; i++) {
            new_option =  { value: labels[i].name, label: labels[i].name };
            label_options.push(new_option);
        }
        return label_options;
   };

   const corrected_label_options=buildCorrectEventLabels(corrected_event_type, labelManager);

   return (
        <div>
            <form onSubmit={handleSubmit}>
                <CardHeader>
                    <Row>
                        <Col md={12}>
                          {t('event_feedback_report.new_feedback')}
                        </Col>
                    </Row>
                </CardHeader>
                <CardBody>
                    <Row>
                        <Col xs="12" sm="3" className="form" >
                            <div className="form__form-group">
                                <span className="form__form-group-label">
                                  {t('event_feedback_report.label.ai_decision_quality')}
                                </span>
                                <div className="form__form-group-field">
                                    <Field
                                        component={renderSelectField}
                                        name="ai_decision_quality"
                                        type="select"
                                        options={AI_DECISION_OPTIONS}
                                    />
                                </div>
                            </div>
                        </Col>


                        <Col xs="12" sm="3" className="form" >
                            <div className="form__form-group">
                                <span className="form__form-group-label">
                                  {t('event_feedback_report.label.corrected_event_type')}
                                </span>
                                <div className="form__form-group-field">
                                    <Field
                                        component={renderSelectField}
                                        name="corrected_event_type"
                                        type="select"
                                        options={EVENT_TYPE_OPTIONS}
                                    />
                                </div>
                            </div>
                        </Col>

                         <Col xs="12" sm="3" className="form" >
                            <div className="form__form-group">
                                <span className="form__form-group-label">
                                  {t('event_feedback_report.label.corrected_label')}
                                </span>
                                <div className="form__form-group-field">
                                    <Field
                                        component={renderSelectField}
                                        name="corrected_label"
                                        type="select"
                                        options={corrected_label_options}
                                        onChange={onLabelItemSelect}
                                    />
                                </div>
                            </div>
                        </Col>

                        <Col xs="12" sm="3" className="form" >
                            <div className="form__form-group">
                                <span className="form__form-group-label">
                                  {t('event_feedback_report.label.corrected_severity')}
                                </span>
                                <div className="form__form-group-field">
                                    <Field
                                        component={renderSelectField}
                                        name="corrected_severity"
                                        type="select"
                                        options={SEVERITY_OPTIONS}
                                    />
                                </div>
                            </div>
                        </Col>
                    </Row>
                    <Row>

                        <Col xs="12" sm="3" className="form " >
                            <div className="form__form-group">
                                <span className="form__form-group-label">
                                  {t('event_feedback_report.label.action_date')}
                                </span>
                                <div className="form__form-group-field">
                                   <Field
                                        name="action_date"
                                        component={renderDatePickerField}
                                   />
                                   <div className="form__form-group-icon">
                                        <i className="fa fa-calendar"></i>
                                   </div>
                                </div>
                            </div>
                        </Col>

                        <Col xs="12" sm="4" className="form " >
                            <div className="form__form-group">
                                <span className="form__form-group-label">
                                  {t('event_feedback_report.label.action')}
                                </span>
                                <div className="form__form-group-field">
                                    <Field
                                        component={renderField}
                                        name="action"
                                        type="text"
                                        placeholder="Action taken"
                                    />
                                </div>
                            </div>
                        </Col>

                        <Col xs="12" sm="5" className="form " >
                            <div className="form__form-group">
                                <span className="form__form-group-label">
                                  {t('event_feedback_report.label.comments')}
                                </span>
                                <div className="form__form-group-field">
                                    <Field
                                        component={renderField}
                                        name="comments"
                                        type="text"
                                        placeholder="Write your comments"
                                    />
                                </div>
                            </div>
                        </Col>

                    </Row>
                    <Row>
                        <Col sm={12} className="text-right">
                            <Button
                                type="button"
                                className="icon rm-m-b"
                                color="secondary"
                                onClick={props.onCancel}
                            >
                                <p>{t('event_feedback_report.label.cancel')}</p>
                            </Button>

                            <Button
                                type="submit" disabled={submitting}
                                className="icon rm-m-b"
                                color="success"
                            >
                                <p>{t('event_feedback_report.label.save')}</p>
                            </Button>
                        </Col>
                    </Row>
                </CardBody>
            </form>
            <CreateNewFaultForm handleCreateLabelToggle={handleCreateNewLabel} isToggleModal={props.isCreateNewLabel} />
        </div>
    );
};

function mapStateToProps(state, ownProps) {
    let { initialValues, labelManager} = ownProps;
    //form_data = form_data && Object.keys(form_data).length > 0 ? form_data : {};
    initialValues.modalDisplay = false;
    let corrected_event_type = selector(state, "corrected_event_type");
    if (!corrected_event_type){
        corrected_event_type = initialValues.corrected_event_type;
    }

    console.log({initialValues});

    return {
        initialValues: initialValues,
        corrected_event_type,
        isCreateNewLabel : state.feedback.isCreateNewLabel,
        labelManager
    };
}

let FeedbackReport = reduxForm({
    validate: validate,
    form: "FeedbackReportForm",
    enableReinitialize: true
})(FeedbackReportForm);

const selector = formValueSelector('FeedbackReportForm');

export default withTranslation('common') (connect(state => mapStateToProps,{createNewLabelToggle, createLabel})(FeedbackReport));
